import Vue from 'vue'
import VueRouter from 'vue-router'
import Layout from '@/layout'

Vue.use(VueRouter)



const router = new VueRouter({
	routes: [{
			path: '/',
			redirect: '/home/index',
			component: () => import('@/views/login/index'),
			meta: {
				title: '登录',
				icon: 'login',
				affix: false
			}
		},
		{
			path: '/login',
			component: () => import('@/views/login/index'),
			meta: {
				title: '登录',
				icon: 'login',
				affix: false
			}
		}, {
			path: '/password',
			component: () => import('@/views/login/password'),
			meta: {
				title: '登录',
				icon: 'login',
				affix: false
			}
		},
		{
			path: '/detail_x',
			component: () => import('@/views/procure/productdetail'),
			name: '产品详情',
			meta: {
				title: '产品详情',
				affix: false
			}
		},
		{
			path: '/home',
			component: Layout,
			name: '主页',
			meta: {
				title: '主页',
				icon: 'home',
				affix: true
			},
			children: [{
					path: 'index',
					component: () => import('@/views/home/index'),
					name: '我的主页',
					meta: {
						title: '我的主页',
						icon: 'documentation',
						affix: true
					}
				},
				{
					path: 'journalism',
					component: () => import('@/views/home/journalism'),
					name: '新闻详情',
					meta: {
						title: '新闻详情',
						affix: false
					}
				},
				{
					path: 'morenews',
					component: () => import('@/views/home/morenews'),
					name: '更多新闻',
					meta: {
						title: '更多新闻',
						affix: false
					}
				}
			]
		},
		{
			path: '/procure',
			component: Layout,
			name: '门店销售',
			meta: {
				title: '门店销售',
				icon: 'shopping-cart',
				affix: true
			},
			children: [
				// {
				// 	path: 'potential-clients',
				// 	component: () => import('@/views/market/potential-clients'),
				// 	name: '意向客户信息记录',
				// 	meta: {
				// 		title: '意向客户信息记录',
				// 		icon: 'documentation',
				// 		affix: true
				// 	}
				// },
				// {
				// 	path: 'market',
				// 	component: () => import('@/views/market/market'),
				// 	name: '订单管理',
				// 	meta: {
				// 		title: '订单管理',
				// 		icon: 'documentation',
				// 		affix: true
				// 	}
				// },
				// {
				// 	path: 'new',
				// 	component:()=>import('@/views/market/new'),
				// 	name:'订单',
				// 	meta: {
				// 		title: '订单',
				// 		icon:'documentation',
				// 		affix: true
				// 	}
				// },
				{
					path: 'addorder',
					component: () => import('@/views/market/addorder'),
					name: '订单开立',
					meta: {
						title: '订单开立',
						affix: false
					}
				},
				{
					path: 'product',
					component: () => import('@/views/procure/product'),
					name: '在售产品',
					meta: {
						title: '在售产品',
						icon: 'documentation',
						affix: true
					}
				},
				{
					path: 'product/detail',
					component: () => import('@/views/procure/productdetail'),
					name: '产品详情',
					meta: {
						title: '产品详情',
						affix: false
					}
				},
				// {
				// 	path: 'promote',
				// 	component: () => import('@/views/procure/promote'),
				// 	name: '促销活动',
				// 	meta: {
				// 		title: '促销活动',
				// 		icon: 'documentation',
				// 		affix: true
				// 	}
				// },
				// {
				// 	path: 'promote13232',
				// 	component: () => import('@/views/procure/promote'),
				// 	name: '配件',
				// 	meta: {
				// 		title: '配件',
				// 		icon: 'documentation',
				// 		affix: true
				// 	}
				// },
				{
					path: 'cart',
					component: () => import('@/views/procure/shoppingcart'),
					name: '购物车',
					meta: {
						title: '购物车',
						icon: 'documentation',
						affix: true
					}
				}
			]
		},
		{
			path: '/order',
			component: Layout,
			name: '门店管理',
			meta: {
				title: '门店管理',
				icon: 'file-text',
				affix: true
			},
			children: [{
					path: 'promote22232',
					component: () => import('@/views/order/list'),
					name: '订单管理',
					meta: {
						title: '订单管理',
						icon: 'documentation',
						affix: true
					}
				},
{
					path: 'order2023',
					component: () => import('@/views/order/list2023'),
					name: '订单管理2023',
					meta: {
						title: '订单管理2023',
						icon: 'documentation',
						affix: true
					}
				},
				{
					path: 'confirm',
					component: () => import('@/views/order/confirm'),
					name: '生成订单',
					meta: {
						title: '生成订单',
						icon: 'documentation',
						affix: false
					}
				}, {
					path: 'addOrder',
					component: () => import('@/views/order/addOrder'),
					name: '新增订单',
					meta: {
						title: '新增订单',
						icon: 'documentation',
						affix: false
					}
				}, {
					path: 'order',
					component: () => import('@/views/order/order'),
					name: '订单详情',
					meta: {
						title: '订单详情',
						icon: 'documentation',
						affix: false
					}
				},{
					path: 'order2023',
					component: () => import('@/views/order/order2023'),
					name: '订单详情2023',
					meta: {
						title: '订单详情2023',
						icon: 'documentation',
						affix: false
					}
				}
				, {
					path: 'pay',
					component: () => import('@/views/order/pay'),
					name: '支付方式',
					meta: {
						title: '支付方式',
						icon: 'documentation',
						affix: false
					}
				},
				/*{
					path: 'information',
					component: () => import('@/views/order/information'),
					name: '对账单',
					meta: {
						title: '对账单',
						icon: 'documentation',
						affix: true
					}
				},*/
				{
					path: 'receipt',
					component: () => import('@/views/order/receipt'),
					name: '付款单',
					meta: {
						title: '付款单',
						icon: 'documentation',
						affix: true
					}
				},
				{
					path: 'statement',
					component: () => import('@/views/assets/dataCenter'),
					name: '销售报表',
					meta: {
						title: '销售报表',
						icon: 'documentation',
						affix: true
					}
				},
				{
					path: 'dataCenterpro',
					component: () => import('@/views/assets/dataCenterpro'),
					name: '销售报表(2024)',
					meta: {
						title: '销售报表(2024)',
						icon: 'documentation',
						affix: true
					}
				},
				{
					path: 'dataCenterpro2023',
					component: () => import('@/views/assets/dataCenterpro2023'),
					name: '销售报表(2023)',
					meta: {
						title: '销售报表(2023)',
						icon: 'documentation',
						affix: true
					}
				},
			],
		},
		{
			path: '/assets',
			component: Layout,
			name: '个人资产',
			meta: {
				title: '个人资产',
				icon: 'user',
				affix: true
			},
			children: [{
				path: 'index',
				component: () => import('@/views/assets/index'),
				name: '我的账户',
				meta: {
					title: '我的账户',
					icon: 'documentation',
					affix: true
				}
			}, 
			{
				path: 'index2023',
				component: () => import('@/views/assets/index2023'),
				name: '	账户余额2023',
				meta: {
					title: '账户余额2023',
					icon: 'documentation',
					affix: true
				}
			}, 
			],
		}
	],
})


router.beforeEach((to, from, next) => {
  if (to.path.startsWith('/login')) {
    document.cookie="user_token=";
    next();
  } else {
    let token = document.cookie.split("user_token=")[1];
    if (!token) {
      //未登录  跳回主页面
      next({
        path: '/login'
      });
    } else {
      next();
    }
  }

});




export default router
